import React from 'react';
import { CheckIcon, XMarkIcon, InformationCircleIcon } from '../../../../components/Icons';

interface AdminVisibilityMatrixTableProps {
  rolesToManage: string[];
  uniqueOwners: string[];
  isLoadingProps: boolean;
  isAllowed: (role: string, owner: string) => boolean;
  onTogglePermission: (role: string, owner: string) => void;
}

export const AdminVisibilityMatrixTable: React.FC<AdminVisibilityMatrixTableProps> = ({
  rolesToManage,
  uniqueOwners,
  isLoadingProps,
  isAllowed,
  onTogglePermission,
}) => {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="p-4 bg-sky-50 border-b border-sky-100 flex items-center gap-2 text-sky-800 text-xs font-bold uppercase tracking-wider">
        <InformationCircleIcon className="w-4 h-4" />
        Si un rol no tiene fuentes seleccionadas, no verá ningún inmueble de esas fuentes.
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50/50">
              <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-wider sticky left-0 bg-gray-50/50 z-10">
                Fuente (Owner)
              </th>
              {rolesToManage.map((role) => (
                <th
                  key={role}
                  className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-wider text-center min-w-[120px]"
                >
                  {String(role || '').replace(/_/g, ' ')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {uniqueOwners.length === 0 && !isLoadingProps && (
              <tr>
                <td
                  colSpan={rolesToManage.length + 1}
                  className="px-6 py-10 text-center text-gray-400 text-sm italic"
                >
                  No se detectaron fuentes en el inventario activo.
                </td>
              </tr>
            )}
            {uniqueOwners.map((owner) => (
              <tr key={owner} className="hover:bg-gray-50/30 transition-colors">
                <td className="px-6 py-4 text-xs font-bold text-gray-900 sticky left-0 bg-white z-10 border-r border-gray-50">
                  {String(owner || '').replace(/[-_]/g, ' ')}
                </td>
                {rolesToManage.map((role) => {
                  const allowed = isAllowed(role, owner);
                  return (
                    <td key={`${owner}-${role}`} className="px-6 py-4 text-center">
                      <button
                        onClick={() => onTogglePermission(role, owner)}
                        className={`w-10 h-10 rounded-xl flex items-center justify-center mx-auto transition-all ${
                          allowed
                            ? 'bg-emerald-100 text-emerald-600 shadow-inner'
                            : 'bg-gray-100 text-gray-300 hover:bg-gray-200'
                        }`}
                      >
                        {allowed ? <CheckIcon className="w-5 h-5" /> : <XMarkIcon className="w-4 h-4 opacity-50" />}
                      </button>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
